import script from "./AdministratorRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorRequests.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorRequests.vue?vue&type=style&index=0&id=00cdd6f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cdd6f6"]])

export default __exports__